import { extend } from 'underscore';

export const getValidationMessageStyles = ({
  styleOverrides = {},
}) => () => ({
  validationError: extend({
    fontSize: 14,
    lineHeight: 2,
    marginRight: 16,
    display: 'block',
    width: '100%',
    textAlign: 'center',
  }, styleOverrides.validationError),
});
